/**
 * Rounds a number to the specified number of decimal places
 * @param number - Number to round
 * @param maxDecimalDigits - Maximum number of decimal digits (default: 2)
 * @returns Rounded number
 */
const roundNumber = (
  number: number | null | undefined,
  maxDecimalDigits = 2
): number => {
  return (
    Math.round((number || 0) * 10 ** maxDecimalDigits) / 10 ** maxDecimalDigits
  )
}
export default roundNumber
